import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
// In a larger app, these would be in separate JSON files
const resources = {
  en: {
    translation: {
      "nav.home": "Home",
      "nav.models": "Models",
      "nav.categories": "Categories",
      "nav.premium": "Premium",
      "nav.creator": "Become a Creator",
      "nav.affiliates": "Affiliates",
      "nav.contact": "Contact",
      "nav.wallet": "Wallet",
      
      "auth.login": "Log In",
      "auth.signup": "Sign Up",
      
      "search.placeholder": "Search videos, models...",
      
      "hero.title": "Welcome to FreakMe.Fun",
      "hero.subtitle": "Discover exclusive premium content from our verified models. Join thousands of members today.",
      "hero.cta": "Get Premium Access",
      
      "category.all_categories": "All Categories",
      "categories.meta.Solo": "Solo performances and intimate moments",
      "categories.meta.Couples": "Passionate couples content",
      "categories.meta.Premium": "High-quality premium exclusives",
      "categories.meta.Amateur": "Authentic amateur creators",
      "categories.meta.Professional": "Studio quality productions",
      "categories.meta.Fetish": "Explore unique interests",
      "categories.meta.Cosplay": "Fantasy and roleplay content",
      "categories.meta.Interactive": "Engage with creators live",
      "categories.meta.POV": "Immersive point-of-view",
      "categories.meta.ASMR": "Sensual audio experiences",
      "categories.meta.Massage": "Relaxation and sensuality",
      "categories.meta.Outdoor": "Nature and adventure",
      "category.all": "All",
      "category.new": "New",
      "category.trending": "Trending",
      "category.popular": "Popular",
      "category.featured": "Featured",
      "category.vip": "VIP",
      "category.premium": "Premium",
      "category.exclusive": "Exclusive",
      "category.hd": "HD",
      "category.4k": "4K",

      "section.trending": "Trending Now",
      "section.latest": "Latest Uploads",
      "section.free": "Free Previews",
      "section.featured_models": "Featured Models",
      
      "common.view_all": "View All",
      "common.prev": "Prev",
      "common.next": "Next",
      "common.videos_count": "{{count}} videos",
      "common.premium_badge": "PREMIUM",
      
      "home.loading_models": "Loading models...",
      "home.no_trending": "No trending videos yet. Content coming soon!",
      "home.no_models": "No featured models yet. Check back soon!",
      "home.no_videos": "No videos available yet",
      "home.empty_state": "No videos available.",

      "models.title": "Our Models",
      "models.subtitle": "Browse our collection of verified content creators. Each model brings unique style and exclusive content.",
      "footer.about": "About Us",
      "footer.careers": "Careers",
      "footer.press": "Press",
      "footer.blog": "Blog",
      "footer.help": "Help Center",
      "footer.contact": "Contact Us",
      "footer.safety": "Safety Tips",
      "footer.faq": "FAQ",
      "footer.terms": "Terms of Service",
      "footer.privacy": "Privacy Policy",
      "footer.cookies": "Cookie Policy",
      "footer.dmca": "DMCA",
      "footer.become_model": "Become a Model",
      "footer.partners": "Content Partners",
      "footer.affiliates": "Affiliate Program",
      "footer.advertise": "Advertise",
      "footer.rights": "© {{year}} FreakMe.Fun. All rights reserved. 18+ Only.",
      
      // Campaign/Casting Page
      "campaign.logo": "FreakMe.Fun Studio",
      "campaign.join_casting": "Join the {{location}} Casting",
      "campaign.form.name": "Full Name",
      "campaign.form.name_placeholder": "Your stage or real name",
      "campaign.form.email": "Email Address",
      "campaign.form.email_placeholder": "you@example.com",
      "campaign.form.social": "Instagram / Twitter / Link",
      "campaign.form.social_placeholder": "@username or link",
      "campaign.form.experience": "Experience Level",
      "campaign.form.exp_none": "New to this",
      "campaign.form.exp_some": "Some experience",
      "campaign.form.exp_pro": "Professional model",
      "campaign.form.exp_creator": "Content Creator / Influencer",
      "campaign.form.submit": "Submit Application",
      "campaign.form.sending": "Sending...",
      "campaign.success.title": "Application Received! 🎉",
      "campaign.success.message": "We'll be in touch shortly.",
      "campaign.success.cta": "Go to Main Site",
      "campaign.error": "Something went wrong. Please try again.",
      
      // Contact Page
      "contact.title": "📬 Contact Us",
      "contact.subtitle": "Have questions, feedback, or need support? We're here to help.",
      "contact.form.name": "Name *",
      "contact.form.name_placeholder": "Your name",
      "contact.form.email": "Email *",
      "contact.form.email_placeholder": "your@email.com",
      "contact.form.subject": "Subject *",
      "contact.form.subject_placeholder": "Select a subject",
      "contact.subject.general": "General Inquiry",
      "contact.subject.support": "Technical Support",
      "contact.subject.billing": "Billing Question",
      "contact.subject.model": "Become a Model",
      "contact.subject.dmca": "DMCA / Copyright",
      "contact.subject.partnership": "Partnership",
      "contact.subject.other": "Other",
      "contact.form.message": "Message *",
      "contact.form.message_placeholder": "How can we help you?",
      "contact.form.submit": "Send Message",
      "contact.form.sending": "Sending...",
      "contact.success.title": "Thank You!",
      "contact.success.message": "Your message has been received. We'll get back to you within 24-48 hours.",
      "contact.success.cta": "Send Another Message",
      "contact.info.email": "Email",
      "contact.info.discord": "Discord",
      "contact.info.discord_text": "Join our community",
      "contact.info.twitter": "Twitter"
    }
  },
  es: {
    translation: {
      "nav.home": "Inicio",
      "nav.models": "Modelos",
      "nav.categories": "Categorías",
      "nav.premium": "Premium",
      "nav.creator": "Ser Creador",
      "nav.affiliates": "Afiliados",
      "nav.contact": "Contacto",
      "nav.wallet": "Billetera",

      "auth.login": "Entrar",
      "auth.signup": "Registro",
      
      "search.placeholder": "Buscar videos, modelos...",
      
      "hero.title": "Bienvenido a FreakMe.Fun",
      "hero.subtitle": "Descubre contenido premium exclusivo de nuestros modelos verificados. Únete a miles de miembros hoy.",
      "hero.cta": "Obtener Acceso Premium",
      
      "category.all": "Todos",
      "category.new": "Nuevos",
      "category.trending": "Tendencias",
      "category.popular": "Populares",
      "category.featured": "Destacados",
      "category.vip": "VIP",
      "category.premium": "Premium",
      "category.exclusive": "Exclusivo",
      "category.hd": "HD",
      "category.4k": "4K",

      "section.trending": "Tendencias Ahora",
      "section.latest": "Últimas Subidas",
      "section.free": "Vistas Previas Gratis",
      "section.featured_models": "Modelos Destacados",
      
      "common.view_all": "Ver Todo",
      "common.prev": "Ant",
      "common.next": "Sig",
      "common.videos_count": "{{count}} videos",
      "common.premium_badge": "PREMIUM",
      
      "home.loading_models": "Cargando modelos...",
      "home.no_trending": "No hay videos en tendencia aún. ¡Contenido pronto!",
      "home.no_models": "No hay modelos destacados aún. ¡Vuelve pronto!",
      "home.no_videos": "No hay videos disponibles aún",
      "home.empty_state": "No hay videos disponibles.",

      "models.title": "Nuestros Modelos",
      "models.subtitle": "Explora nuestra colección de creadores de contenido verificados. Cada modelo trae un estilo único y contenido exclusivo.",
      "footer.about": "Sobre Nosotros",
      "footer.careers": "Carreras",
      "footer.press": "Prensa",
      "footer.blog": "Blog",
      "footer.help": "Centro de Ayuda",
      "footer.contact": "Contáctanos",
      "footer.safety": "Consejos de Seguridad",
      "footer.faq": "FAQ",
      "footer.terms": "Términos de Servicio",
      "footer.privacy": "Política de Privacidad",
      "footer.cookies": "Política de Cookies",
      "footer.dmca": "DMCA",
      "footer.become_model": "Ser Modelo",
      "footer.partners": "Socios de Contenido",
      "footer.affiliates": "Programa de Afiliados",
      "footer.advertise": "Publicidad",
      "footer.rights": "© {{year}} FreakMe.Fun. Todos los derechos reservados. Solo +18.",
      
      // Campaign/Casting Page
      "campaign.logo": "FreakMe.Fun Studio",
      "campaign.join_casting": "Únete al Casting de {{location}}",
      "campaign.form.name": "Nombre Completo",
      "campaign.form.name_placeholder": "Tu nombre artístico o real",
      "campaign.form.email": "Correo Electrónico",
      "campaign.form.email_placeholder": "tu@ejemplo.com",
      "campaign.form.social": "Instagram / Twitter / Enlace",
      "campaign.form.social_placeholder": "@usuario o enlace",
      "campaign.form.experience": "Nivel de Experiencia",
      "campaign.form.exp_none": "Nuevo en esto",
      "campaign.form.exp_some": "Algo de experiencia",
      "campaign.form.exp_pro": "Modelo profesional",
      "campaign.form.exp_creator": "Creador de Contenido / Influencer",
      "campaign.form.submit": "Enviar Solicitud",
      "campaign.form.sending": "Enviando...",
      "campaign.success.title": "¡Solicitud Recibida! 🎉",
      "campaign.success.message": "Te contactaremos pronto.",
      "campaign.success.cta": "Ir al Sitio Principal",
      "campaign.error": "Algo salió mal. Por favor intenta de nuevo.",
      
      // Contact Page
      "contact.title": "📬 Contáctanos",
      "contact.subtitle": "¿Tienes preguntas, comentarios o necesitas soporte? Estamos aquí para ayudarte.",
      "contact.form.name": "Nombre *",
      "contact.form.name_placeholder": "Tu nombre",
      "contact.form.email": "Correo *",
      "contact.form.email_placeholder": "tu@correo.com",
      "contact.form.subject": "Asunto *",
      "contact.form.subject_placeholder": "Selecciona un asunto",
      "contact.subject.general": "Consulta General",
      "contact.subject.support": "Soporte Técnico",
      "contact.subject.billing": "Pregunta de Facturación",
      "contact.subject.model": "Ser Modelo",
      "contact.subject.dmca": "DMCA / Derechos de Autor",
      "contact.subject.partnership": "Alianzas",
      "contact.subject.other": "Otro",
      "contact.form.message": "Mensaje *",
      "contact.form.message_placeholder": "¿Cómo podemos ayudarte?",
      "contact.form.submit": "Enviar Mensaje",
      "contact.form.sending": "Enviando...",
      "contact.success.title": "¡Gracias!",
      "contact.success.message": "Tu mensaje ha sido recibido. Te responderemos en 24-48 horas.",
      "contact.success.cta": "Enviar Otro Mensaje",
      "contact.info.email": "Correo",
      "contact.info.discord": "Discord",
      "contact.info.discord_text": "Únete a nuestra comunidad",
      "contact.info.twitter": "Twitter"
    }
  },
  pt: {
    translation: {
      "nav.home": "Início",
      "nav.models": "Modelos",
      "nav.categories": "Categorias",
      "nav.premium": "Premium",
      "nav.creator": "Seja um Criador",
      "nav.affiliates": "Afiliados",
      "nav.contact": "Contato",
      "nav.wallet": "Carteira",

      "auth.login": "Entrar",
      "auth.signup": "Cadastrar",
      
      "search.placeholder": "Buscar vídeos, modelos...",
      
      "hero.title": "Bem-vindo ao FreakMe.Fun",
      "hero.subtitle": "Descubra conteúdo premium exclusivo de nossos modelos verificados. Junte-se a milhares de membros hoje.",
      "hero.cta": "Obter Acesso Premium",

      "category.all": "Todos",
      "category.new": "Novos",
      "category.trending": "Em Alta",
      "category.popular": "Populares",
      "category.featured": "Destaques",
      "category.vip": "VIP",
      "category.premium": "Premium",
      "category.exclusive": "Exclusivo",
      "category.hd": "HD",
      "category.4k": "4K",
      
      "section.trending": "Em Alta",
      "section.latest": "Novos Envios",
      "section.free": "Prévias Grátis",
      "section.featured_models": "Modelos em Destaque",
      
      "common.view_all": "Ver Tudo",
      "common.prev": "Ant",
      "common.next": "Prox",
      "common.videos_count": "{{count}} vídeos",
      "common.premium_badge": "PREMIUM",
      
      "home.loading_models": "Carregando modelos...",
      "home.no_trending": "Sem vídeos em alta ainda. Conteúdo em breve!",
      "home.no_models": "Sem modelos em destaque ainda. Volte logo!",
      "home.no_videos": "Sem vídeos disponíveis ainda",
      "home.empty_state": "Sem vídeos disponíveis.",

      "models.title": "Nossos Modelos",
      "models.subtitle": "Navegue pela nossa coleção de criadores de conteúdo verificados. Cada modelo traz um estilo único e conteúdo exclusivo.",
      "footer.about": "Sobre Nós",
      "footer.careers": "Carreiras",
      "footer.press": "Imprensa",
      "footer.blog": "Blog",
      "footer.help": "Central de Ajuda",
      "footer.contact": "Fale Conosco",
      "footer.safety": "Dicas de Segurança",
      "footer.faq": "FAQ",
      "footer.terms": "Termos de Uso",
      "footer.privacy": "Política de Privacidade",
      "footer.cookies": "Política de Cookies",
      "footer.dmca": "DMCA",
      "footer.become_model": "Seja um Modelo",
      "footer.partners": "Parceiros de Conteúdo",
      "footer.affiliates": "Programa de Afiliados",
      "footer.advertise": "Anuncie",
      "footer.rights": "© {{year}} FreakMe.Fun. Todos os direitos reservados. Somente 18+.",
      
      // Campaign/Casting Page
      "campaign.logo": "FreakMe.Fun Studio",
      "campaign.join_casting": "Participe do Casting {{location}}",
      "campaign.form.name": "Nome Completo",
      "campaign.form.name_placeholder": "Seu nome artístico ou real",
      "campaign.form.email": "Endereço de E-mail",
      "campaign.form.email_placeholder": "voce@exemplo.com",
      "campaign.form.social": "Instagram / Twitter / Link",
      "campaign.form.social_placeholder": "@usuario ou link",
      "campaign.form.experience": "Nível de Experiência",
      "campaign.form.exp_none": "Nova nisso",
      "campaign.form.exp_some": "Alguma experiência",
      "campaign.form.exp_pro": "Modelo profissional",
      "campaign.form.exp_creator": "Criadora de Conteúdo / Influencer",
      "campaign.form.submit": "Enviar Candidatura",
      "campaign.form.sending": "Enviando...",
      "campaign.success.title": "Candidatura Recebida! 🎉",
      "campaign.success.message": "Entraremos em contato em breve.",
      "campaign.success.cta": "Ir para o Site Principal",
      "campaign.error": "Algo deu errado. Por favor tente novamente.",
      
      // Contact Page
      "contact.title": "📬 Fale Conosco",
      "contact.subtitle": "Tem perguntas, feedback ou precisa de suporte? Estamos aqui para ajudar.",
      "contact.form.name": "Nome *",
      "contact.form.name_placeholder": "Seu nome",
      "contact.form.email": "E-mail *",
      "contact.form.email_placeholder": "seu@email.com",
      "contact.form.subject": "Assunto *",
      "contact.form.subject_placeholder": "Selecione um assunto",
      "contact.subject.general": "Dúvida Geral",
      "contact.subject.support": "Suporte Técnico",
      "contact.subject.billing": "Pergunta sobre Pagamento",
      "contact.subject.model": "Ser Modelo",
      "contact.subject.dmca": "DMCA / Direitos Autorais",
      "contact.subject.partnership": "Parceria",
      "contact.subject.other": "Outro",
      "contact.form.message": "Mensagem *",
      "contact.form.message_placeholder": "Como podemos ajudar?",
      "contact.form.submit": "Enviar Mensagem",
      "contact.form.sending": "Enviando...",
      "contact.success.title": "Obrigado!",
      "contact.success.message": "Sua mensagem foi recebida. Responderemos em 24-48 horas.",
      "contact.success.cta": "Enviar Outra Mensagem",
      "contact.info.email": "E-mail",
      "contact.info.discord": "Discord",
      "contact.info.discord_text": "Junte-se à nossa comunidade",
      "contact.info.twitter": "Twitter"
    }
  },
  th: {
    translation: {
      "nav.home": "หน้าแรก",
      "nav.models": "โมเดล",
      "nav.categories": "หมวดหมู่",
      "nav.premium": "พรีเมียม",
      "nav.creator": "เป็นครีเอเตอร์",
      "nav.affiliates": "พันธมิตร",
      "nav.contact": "ติดต่อ",
      "nav.wallet": "กระเป๋าเงิน",

      "auth.login": "เข้าสู่ระบบ",
      "auth.signup": "ลงทะเบียน",
      
      "search.placeholder": "ค้นหาวิดีโอ, โมเดล...",
      
      "hero.title": "ยินดีต้อนรับสู่ FreakMe.Fun",
      "hero.subtitle": "ค้นพบเนื้อหาพรีเมียมสุดพิเศษจากโมเดลที่ผ่านการตรวจสอบของเรา เข้าร่วมกับสมาชิกนับพันวันนี้",
      "hero.cta": "รับสิทธิ์เข้าถึงพรีเมียม",

      "category.all": "ทั้งหมด",
      "category.new": "ใหม่",
      "category.trending": "กำลังมาแรง",
      "category.popular": "ยอดนิยม",
      "category.featured": "แนะนำ",
      "category.vip": "VIP",
      "category.premium": "พรีเมียม",
      "category.exclusive": "Exclusive",
      "category.hd": "HD",
      "category.4k": "4K",
      
      "section.trending": "กำลังมาแรง",
      "section.latest": "อัปโหลดล่าสุด",
      "section.free": "ดูตัวอย่างฟรี",
      "section.featured_models": "โมเดลแนะนำ",
      
      "common.view_all": "ดูทั้งหมด",
      "common.prev": "ก่อนหน้า",
      "common.next": "ถัดไป",
      "common.videos_count": "{{count}} วิดีโอ",
      "common.premium_badge": "พรีเมียม",
      
      "home.loading_models": "กำลังโหลดโมเดล...",
      "home.no_trending": "ยังไม่มีวิดีโอที่กำลังมาแรง เนื้อหาจะมาเร็วๆ นี้!",
      "home.no_models": "ยังไม่มีโมเดลแนะนำ กลับมาดูใหม่เร็วๆ นี้!",
      "home.no_videos": "ยังไม่มีวิดีโอ",
      "home.empty_state": "ยังไม่มีวิดีโอ",

      "footer.about": "เกี่ยวกับเรา",
      "footer.careers": "ร่วมงานกับเรา",
      "footer.press": "สื่อมวลชน",
      "footer.blog": "บล็อก",
      "footer.help": "ศูนย์ช่วยเหลือ",
      "footer.contact": "ติดต่อเรา",
      "footer.safety": "เคล็ดลับความปลอดภัย",
      "footer.faq": "FAQ",
      "footer.terms": "เงื่อนไขการให้บริการ",
      "footer.privacy": "นโยบายความเป็นส่วนตัว",
      "footer.cookies": "นโยบายคุกกี้",
      "footer.dmca": "DMCA",
      "footer.become_model": "สมัครเป็นโมเดล",
      "footer.partners": "พันธมิตรเนื้อหา",
      "footer.affiliates": "โปรแกรมพันธมิตร",
      "footer.advertise": "ลงโฆษณา",
      "footer.rights": "© {{year}} FreakMe.Fun. สงวนลิขสิทธิ์. 18+ เท่านั้น",
      
      // Campaign/Casting Page
      "campaign.logo": "FreakMe.Fun Studio",
      "campaign.join_casting": "สมัครแคสติ้ง {{location}}",
      "campaign.form.name": "ชื่อ-นามสกุล",
      "campaign.form.name_placeholder": "ชื่อจริงหรือชื่อในวงการ",
      "campaign.form.email": "อีเมล",
      "campaign.form.email_placeholder": "you@example.com",
      "campaign.form.social": "Instagram / Twitter / ลิงก์",
      "campaign.form.social_placeholder": "@username หรือลิงก์",
      "campaign.form.experience": "ระดับประสบการณ์",
      "campaign.form.exp_none": "ยังใหม่",
      "campaign.form.exp_some": "มีประสบการณ์บ้าง",
      "campaign.form.exp_pro": "โมเดลมืออาชีพ",
      "campaign.form.exp_creator": "ครีเอเตอร์ / อินฟลูเอนเซอร์",
      "campaign.form.submit": "ส่งใบสมัคร",
      "campaign.form.sending": "กำลังส่ง...",
      "campaign.success.title": "รับใบสมัครแล้ว! 🎉",
      "campaign.success.message": "เราจะติดต่อกลับเร็วๆ นี้",
      "campaign.success.cta": "ไปยังเว็บไซต์หลัก",
      "campaign.error": "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
      
      // Contact Page
      "contact.title": "📬 ติดต่อเรา",
      "contact.subtitle": "มีคำถาม ข้อเสนอแนะ หรือต้องการความช่วยเหลือ? เราพร้อมช่วยคุณ",
      "contact.form.name": "ชื่อ *",
      "contact.form.name_placeholder": "ชื่อของคุณ",
      "contact.form.email": "อีเมล *",
      "contact.form.email_placeholder": "your@email.com",
      "contact.form.subject": "หัวข้อ *",
      "contact.form.subject_placeholder": "เลือกหัวข้อ",
      "contact.subject.general": "สอบถามทั่วไป",
      "contact.subject.support": "ฝ่ายสนับสนุน",
      "contact.subject.billing": "คำถามเรื่องการชำระเงิน",
      "contact.subject.model": "สมัครเป็นโมเดล",
      "contact.subject.dmca": "DMCA / ลิขสิทธิ์",
      "contact.subject.partnership": "พันธมิตร",
      "contact.subject.other": "อื่นๆ",
      "contact.form.message": "ข้อความ *",
      "contact.form.message_placeholder": "เราช่วยอะไรคุณได้บ้าง?",
      "contact.form.submit": "ส่งข้อความ",
      "contact.form.sending": "กำลังส่ง...",
      "contact.success.title": "ขอบคุณ!",
      "contact.success.message": "ได้รับข้อความของคุณแล้ว เราจะตอบกลับภายใน 24-48 ชั่วโมง",
      "contact.success.cta": "ส่งข้อความอีก",
      "contact.info.email": "อีเมล",
      "contact.info.discord": "Discord",
      "contact.info.discord_text": "เข้าร่วมชุมชนของเรา",
      "contact.info.twitter": "Twitter"
    }
  },
  sw: {
    translation: {
       "nav.home": "Nyumbani",
       "nav.models": "Wanamitindo",
       "nav.categories": "Aina",
       "nav.premium": "Premium",
       "nav.creator": "Kuwa Muumbaji",
       "nav.affiliates": "Washirika",
       "nav.contact": "Wasiliana",
       "nav.wallet": "Mkoba",
       
       "auth.login": "Ingia",
       "auth.signup": "Jisajili",
       "search.placeholder": "Tafuta video, wanamitindo...",

       "hero.title": "Karibu FreakMe.Fun",
       "hero.subtitle": "Gundua maudhui ya kipekee ya kulipia kutoka kwa wanamitindo wetu walioidhinishwa. Jiunge na maelfu ya wanachama leo.",
       "hero.cta": "Pata Ufikiaji wa Premium",

       "category.all": "Wote",
       "category.new": "Mpya",
       "category.trending": "Inavuma",
       
       "section.trending": "Inavuma Sasa",
       "section.latest": "Vipakiwa Hivi Punde",
       "section.free": "Hakiki za Bure",
       "section.featured_models": "Wanamitindo Walioangaziwa",
       
       "common.view_all": "Tazama Zote",
       "common.prev": "Nyuma",
       "common.next": "Mbele",

       "footer.about": "Kuhusu Sisi"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
